import {
  DictionarySettingsValueEntity,
  DictionarySettingsValueEntityApi,
} from './entity';

/**
 * Нормализует DictionarySettingsValueEntityApi в DictionarySettingsValueEntity
 * @param raw
 */
export const normalizeDictionarySettingValue = (
  raw: DictionarySettingsValueEntityApi
): DictionarySettingsValueEntity => {
  return {
    id: raw.id,
    fieldId: raw.field_id,
    value: raw.value,
    priority: raw.priority,
  };
};

/**
 * Нормализует DictionarySettingsValueEntity  в DictionarySettingsValueEntityApi
 * @param raw
 */
export const normalizeDictionarySettingValueToServerEntity = (
  raw: DictionarySettingsValueEntity
): DictionarySettingsValueEntityApi => {
  return {
    id: typeof raw.id === 'string' ? undefined : raw.id,
    value: raw.value,
    field_id: raw.fieldId,
    priority: raw.priority,
  };
};
